// js/forms/delivery-catalog.js
// Agrupamento do catálogo de delivery por trade (spec §5.4). A tela deixa de
// ter taxonomia fixa de alvenaria: as seções são as categorias que existirem
// no catálogo do trade ativo. Puro e testado; o DOM fica em js/delivery.js.

// Espelho dos seeds masonry — SÓ para boot offline-frio de org masonry.
export const MASONRY_FALLBACK = {
  '20cm':    [['standards_2h','Standards 2H','pallets'],['bondbeams','Bondbeams','pallets'],['halves','Halves','pallets'],['multiblock','Multiblock','pallets'],['block_lock','Block Lock Bundle','bundles'],['wall_mesh','Wall Mesh','rolls']],
  '10cm':    [['standards_2h','Standards 2H','pallets'],['bondbeams','Bondbeams','pallets'],['halves','Halves','pallets'],['block_lock','Block Lock Bundle','bundles'],['wall_mesh','Wall Mesh','rolls']],
  '15cm':    [['standards_2h','Standards 2H','pallets'],['bondbeams','Bondbeams','pallets'],['halves','Halves','pallets'],['block_lock','Block Lock Bundle','bundles'],['wall_mesh','Wall Mesh','rolls']],
  '25cm':    [['standards_2h','Standards 2H','pallets'],['bondbeams','Bondbeams','pallets'],['halves','Halves','pallets'],['block_lock','Block Lock Bundle','bundles'],['wall_mesh','Wall Mesh','rolls']],
  '30cm':    [['standards_2h','Standards 2H','pallets'],['bondbeams','Bondbeams','pallets'],['halves','Halves','pallets'],['block_lock','Block Lock Bundle','bundles'],['wall_mesh','Wall Mesh','rolls']],
  'special': [['squints','Squints','pallets'],['half_height','Half-Height Pallet','pallets'],['slabs','Slabs','pallets'],['dbl_bullnose_full','Dbl Bullnose Full','pallets'],['dbl_bullnose_half','Dbl Bullnose Halves','pallets'],['sgl_bullnose_full','Sgl Bullnose Full','pallets'],['sgl_bullnose_half','Sgl Bullnose Halves','pallets']],
  'materials': [['mortar_tek','Mortar Tek','pallets'],['blockfill','Blockfill','pallets']],
};

// Sem prototype: um grupo chamado "toString" não pode herdar o label do Object.
const LEGACY_LABELS = Object.assign(Object.create(null), { '20cm': '20cm Blocks', '10cm': '10cm Blocks', '15cm': '15cm Blocks',
  '25cm': '25cm Blocks', '30cm': '30cm Blocks', special: 'Special Blocks',
  materials: 'Materials' });
const LEGACY_ORDER = ['20cm', 'special', 'materials', '10cm', '15cm', '25cm', '30cm'];

export function groupCatalog(rows, trade, catalogOk) {
  let list = (rows || []).filter(r =>
    (r.category || 'other') !== 'other' &&
    (r.pack_key == null || r.pack_key === trade));

  if (!list.length && !catalogOk && trade === 'masonry') {
    list = Object.entries(MASONRY_FALLBACK).flatMap(([category, items]) =>
      items.map(([type_key, name, unit]) => ({ id: type_key, type_key, name, unit, category })));
  }

  const byCat = new Map();
  for (const r of list) {
    if (!byCat.has(r.category)) byCat.set(r.category, []);
    byCat.get(r.category).push(r);
  }
  const cats = [...byCat.keys()].sort((a, b) => {
    const ia = LEGACY_ORDER.indexOf(a), ib = LEGACY_ORDER.indexOf(b);
    if (ia !== -1 && ib !== -1) return ia - ib;
    if (ia !== -1) return -1;
    if (ib !== -1) return 1;
    return a.localeCompare(b);
  });
  return cats.map(category => ({
    category,
    label: LEGACY_LABELS[category] || category,
    items: byCat.get(category),
  }));
}
